'use client';

import { faCircleCheck, faFire } from '@fortawesome/pro-solid-svg-icons';
import { tv } from 'tailwind-variants';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { Icon } from '@/components/ui/icon.component';

export const PROMOTION_PILL_LABEL = 'Preço promocional';
export const COUPON_PILL_LABEL = 'Cupom aplicado';

const pillStyles = tv({
  base: 'flex w-full items-center justify-center gap-1 rounded-sm border px-2 py-1 text-base font-semibold leading-6',
  variants: {
    variant: {
      promotion: 'border-pink-200 bg-pink-100 text-pink-700',
      coupon: 'border-success-300 bg-success-100 text-success-700',
    },
  },
});

interface CartDiscountPillProps {
  variant: 'promotion' | 'coupon';
  dataTestId?: string;
}

export function CartDiscountPill({ variant, dataTestId }: CartDiscountPillProps) {
  const isPromotion = variant === 'promotion';

  return (
    <p
      className={pillStyles({ variant })}
      data-testid={dataTestId ?? (isPromotion
        ? DataTestIdEnum.CART_ITEM_PROMOTION_PILL
        : DataTestIdEnum.CART_ITEM_COUPON_PILL)}
    >
      <Icon icon={isPromotion ? faFire : faCircleCheck} className="h-3 w-3" />
      {isPromotion ? PROMOTION_PILL_LABEL : COUPON_PILL_LABEL}
    </p>
  );
}
